/* unplugin-vue-components disabled */import { render } from "./Comment.vue?vue&type=template&id=4dcaeb01&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=4dcaeb01&lang=scss&scoped=true"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dcaeb01"]])

export default __exports__